import { createAction } from "redux-starter-kit";
import {
  DELETE_USER_PROFILE_FAILURE,
  DELETE_USER_PROFILE_REQUEST,
  DELETE_USER_PROFILE_SUCCESS
} from "../types";

const deleteUserProfile = userId => async (dispatch, getState, { api }) => {
  try {
    dispatch(createAction(DELETE_USER_PROFILE_REQUEST)());
    const user = await api.user.deleteUserProfile(userId);
    dispatch(createAction(DELETE_USER_PROFILE_SUCCESS)(user));
  } catch (err) {
    dispatch(createAction(DELETE_USER_PROFILE_FAILURE)(err));
    throw err;
  }
};

export default deleteUserProfile;
